import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AccountResourceApi} from "./api/account-resource.api";

@Injectable()
export class AccountResourceService {
  constructor(private accountResourceApi: AccountResourceApi) {
  }

  get() {
    return this.accountResourceApi.get();
  }

  checkActivation(activationKey) {
    return this.accountResourceApi.checkActivation(activationKey);
  }

  confirm(body) {
    return this.accountResourceApi.confirm(body);
  }

  unlock(userId) {
    return this.accountResourceApi.unlock(userId);
  }

  changePassword(body:Object):Observable<any> {
    return this.accountResourceApi.changePassword(body);
  }

  searchByCertificateNumber(certificateNumber) {
    return this.accountResourceApi.searchByCertificateNumber(certificateNumber);
  }
}
